import axios from "axios";
import store from "../store/index.js";
import Cookie from "js-cookie";
import { MessageBox, Message } from "element-ui";
import { getToken } from "./auth.js";
// //创建axios实例
const service = axios.create({
  baseURL: "/bj-smart-fill",
  timeout: 10*60*1000
});
// const ssoToken = 'woshiwangyunbiexianglanwo';
// //请求拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Litemall-Admin-Token']为自定义key 请根据实际情况自行修改
    //   config.headers.ssoTk = ssoToken;
    // }
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);
// Cookie.set('ssoTk', ssoToken)
//请求拦截的响应
// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
     if (res.code === 501) {
      MessageBox.alert('系统未登录，请重新登录', '错误', {
        confirmButtonText: '确定',
        type: 'error'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      })
      return Promise.reject('error')
    } else if (res.code === 502) {
      MessageBox.alert('系统内部错误，请联系管理员维护', '错误', {
        confirmButtonText: '确定',
        type: 'error'
      })
      return Promise.reject('error')
    } else if (res.code === 503) {
      MessageBox.alert('请求业务目前未支持', '警告', {
        confirmButtonText: '确定',
        type: 'error'
      })
      return Promise.reject('error')
    } else if (res.code === 504) {
      MessageBox.alert('更新数据已经失效，请刷新页面重新操作', '警告', {
        confirmButtonText: '确定',
        type: 'error'
      })
      return Promise.reject('error')
    } else if (res.code === 505) {
      MessageBox.alert('更新失败，请再尝试一次', '警告', {
        confirmButtonText: '确定',
        type: 'error'
      })
      return Promise.reject('error')
    } else if (res.code === 506) {
      return Promise.reject('error')
    } else if(!res.code && res.code !== 0) {
      return response
    }else if (res.code !== 0 && res.code !== 200) {
      // 非5xx的错误属于业务错误，留给具体页面处理
      return Promise.reject(response)
    } else {
      return response
    }
  }, error => {
	  console.log(error,'error')
    Message({
      message: '登录连接超时（后台不能连接，请联系系统管理员）',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })
export default service;
